<template>
    <div class="card" :style="cardStyle()">
      <img v-show="config.showConfig.showThumbnail" class="card-img-top desktop-element"  :height="config.imageHeight" :src="article.thumbnail" :alt="`${article.title} thumbnail`">
      <img v-show="config.showConfig.showThumbnail" class="card-img-top mobile-element" :src="article.thumbnail" :alt="`${article.title} thumbnail`">
      <div class="card-body">
        <h2 class="card-title clean-text-css desktop-element" :style="titleStyle()">{{ article.title }}</h2>
        <h2 class="card-title clean-text-css mobile-element free-size" :style="titleStyle(false)">{{ article.title }}</h2>
        <div v-show="config.showConfig.showContent" class="card-text clean-text-css">
          <p id="summaryArticle" :style="contentStyle()" class="clean-text-css desktop-element" v-html="article.summary" ></p>
          <p id="summaryArticleMobile" :style="contentStyle(false)" class="clean-text-css mobile-element free-size" v-html="article.summary" ></p>
        </div>
        <a v-show="config.showConfig.showButton" href="#" :class="`btn btn-primary float-${config.buttonPosition}`" :style="buttonStyle()">{{ config.readMoreText }}</a>
      </div>
      <div v-show="config.showConfig.showCategories">
        <span v-for="category in article.categories" :key="category.id" :style="buttonStyle()" class="btn btn-small ml-1">{{ category.name }}</span>
      </div>
      <div v-show="config.showConfig.showDate || config.showConfig.showAuthor" style="background: none"  :style="authorDivStyle()" class="card-footer mt-3">
        <span v-show="config.showConfig.showDate" :style="authorStyle()">  {{ formatDate(article.scheduled_date, config.dateFormat) }}</span>
        <a v-show="config.showConfig.showAuthor" href="#" :style="authorStyle()">{{ article.author.name }}</a>
      </div>
    </div>
</template>

<script>
import moment from 'moment/moment';

export default {
  name: 'CardPostSimple',
  props: ['article', 'config'],
  methods: {
    cardStyle() {
      return `background-color: ${this.config.backgroundColor}`;
    },
    titleStyle(desktop = true) {
      return `font-family:  ${this.config.titleStyle.family};
                  font-size: ${(desktop) ? this.config.titleStyle.size : this.config.titleStyle.sizeMobile} !important;
                  text-align: ${this.config.titleStyle.align};
                  font-weight: ${this.config.titleStyle.weight};
                  font-style: ${this.config.titleStyle.style};
                  text-decoration: ${this.config.titleStyle.stroke};
                  color: ${this.config.titleStyle.color}`;
    },
    contentStyle(desktop = true) {
      return `font-family:  ${this.config.contentStyle.family};
                  font-size: ${(desktop) ? this.config.contentStyle.size : this.config.contentStyle.sizeMobile} !important;
                  text-align: ${this.config.contentStyle.align};
                  font-weight: ${this.config.contentStyle.weight};
                  font-style: ${this.config.contentStyle.style};
                  text-decoration: ${this.config.contentStyle.stroke};
                  color: ${this.config.contentStyle.color};
                  height: ${this.config.contentStyle.height};
                  overflow: hidden`;
    },
    formatDate(date, format) {
      return moment(String(date)).format(format);
    },
    buttonStyle() {
      return `background-color: ${this.config.colorDetails}; color: ${this.config.colorTexts}; box-shadow: none`;
    },
    authorDivStyle() {
      return `text-align: ${this.config.titleStyle.align};`;
    },
    authorStyle() {
      return `font-family:  ${this.config.titleStyle.family};   color: ${this.config.colorSubTexts}`;
    }
  },
  mounted() {
    $('#summaryArticle > p').addClass('clean-text-css');
    $('#summaryArticleMobile > p').addClass('clean-text-css');
  },
  watch: {
    config() {
      $('#summaryArticle > p').addClass('clean-text-css');
      $('#summaryArticleMobile > p').addClass('clean-text-css');
    },
    article(value) {
      // do nothing
    }
  }
};
</script>

<style scoped>

  .card{
    padding: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Generic/PostCards/Simple.vue